export default {
    '0':'晴',
    '1':'晴',
    '2':'晴',
    '3':'晴',
    '4':'多云',
    '5':'晴天有云',
    '6':'晴天有云',
    '7':'多云',
    '8':'多云',
    '9':'多云',
    '10':'阵雨',
    '11':'雷阵雨',
    '12':'冰雹',
    '13':'小雨',
    '14':'中雨',
    '15':'大雨',
    '16':'大暴雨',
    '17':'大暴雨',
    '18':'大暴雨',
    '19':'小雨',
    '20':'雨夹雪',
    '21':'阵雪',
    '22':'小雪',
    '23':'中雪',
    '24':'大雪',
    '25':'暴雪',
    '26':'沙尘',
    '27':'风沙',
    '28':'沙尘暴',
    '29':'沙尘暴',
    '30':'雾',
    '31':'霾',
    '32':'飓风',
    '33':'飓风',
    '34':'飓风',
    '35':'飓风',
    '36':'飓风',
    '37':'多云',
    '38':'晴',
}